// extracted by mini-css-extract-plugin
export var cardContent = "DoctorCard-module--cardContent--FoA1-";
export var credentials = "DoctorCard-module--credentials--+NFG8";
export var doctorCard = "DoctorCard-module--doctorCard--T6YiL";
export var doctorImage = "DoctorCard-module--doctorImage--tbxaf";
export var doctorName = "DoctorCard-module--doctorName--cGmq7";
export var experience = "DoctorCard-module--experience--byoMp";
export var imageWrapper = "DoctorCard-module--imageWrapper--b9Jzn";